import { render, staticRenderFns } from "./BranchesTableV2.vue?vue&type=template&id=12f6342c&"
import script from "./BranchesTableV2.vue?vue&type=script&lang=js&"
export * from "./BranchesTableV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12f6342c')) {
      api.createRecord('12f6342c', component.options)
    } else {
      api.reload('12f6342c', component.options)
    }
    module.hot.accept("./BranchesTableV2.vue?vue&type=template&id=12f6342c&", function () {
      api.rerender('12f6342c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Tables/BranchesTableV2.vue"
export default component.exports